import React, { useState, useEffect } from "react";
import { Container, Background, Hr, Titulo, Table, ButtonRetiradas, Botoes } from "./style";
import api from "../../../services/api";
import { Swal } from "../../../services/SwalTemplates";
import Pagination from "../../../components/Pagination";
import { formatDatesHoras } from "../../../utils/formatDates";

export default function RelatorioRetiradas() {
  const [retiradas, setRetiradas] = useState([]);
  const [todasRetiradas, setTodasRetiradas] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [ano] = useState(new Date().getFullYear());
  const [retirou, setRetirou] = useState(true);

  useEffect(() => {
    carregarRetiradas();
  }, [ano]);

  const carregarRetiradas = () => {
    api
      .get(`/rh/controle-cestas/listar-qrcodes/${ano}`)
      .then((response) => {
        const items = response.data.items || [];
        setTodasRetiradas(items);
        setRetiradas(items);
        filterRetirou(retirou, items);
      })
      .catch((e) => {
        Swal.fire({
          title: "Atenção!",
          text: `${e.response?.data?.error || "Não foi possível consultar as retiradas!"}`,
          icon: "error",
        });
      })
  };

  function filterRetirou(arg, sourceList = todasRetiradas) {
    if (!sourceList || sourceList.length === 0) {
      setRetiradas([]);
      setPage(1);
      return;
    }
    const retiradasFiltradas = sourceList.filter((r) => {
      let ret;
      const dataRetiradaCesta = r.data_retirada_cesta ? formatDatesHoras(r.data_retirada_cesta) : "";
      const dataRetiradaBrinquedo = r.data_retirada_brinquedo ? formatDatesHoras(r.data_retirada_brinquedo) : "";

      if (arg === true) {
        ret = dataRetiradaCesta !== "" || dataRetiradaBrinquedo !== "";
      } else {
        ret = dataRetiradaCesta === "" && dataRetiradaBrinquedo === "";
      }
      return ret;
    });

    setRetiradas(retiradasFiltradas);
    setPage(1);
  }

  useEffect(() => {
    setTotalPages(Math.ceil(retiradas.length / 15));
  }, [retiradas]);

  return (
    <Background>
      <Container>
        <Titulo>Relatório de Retiradas - Ano {ano}</Titulo>
        <Hr />
        <Table>
          <Botoes>
            <ButtonRetiradas
              $retirou={retirou}
              onClick={() => {
                setRetirou(true);
                filterRetirou(true);
              }}
            >
              Retirou
            </ButtonRetiradas>
            <ButtonRetiradas
              $retirou={!retirou}
              onClick={() => {
                setRetirou(false);
                filterRetirou(false);
              }}
            >
              Não Retirou
            </ButtonRetiradas>
          </Botoes>
          <table>
            <thead>
              <tr>
                <th>Matrícula</th>
                <th>Colaborador</th>
                <th>Cesta</th>
                <th>Brinquedo</th>
                <th>Retirada Cesta</th>
                <th>Retirada Brinquedo</th>
              </tr>
            </thead>
            <tbody>
              {retiradas.length === 0 ? (
                <tr>
                  <td colSpan="6" style={{ textAlign: "center" }}>
                    Nenhum registro encontrado
                  </td>
                </tr>
              ) : (
                retiradas.slice((page - 1) * 15, page * 15).map((d, i) => (
                  <tr key={i}>
                    <td data-title="Matrícula">{d.matricula}</td>
                    <td data-title="Colaborador" className="td-left">
                      {d.nome?.toUpperCase() || "-"}
                    </td>
                    <td data-title="Cesta">{d.cesta_natal ? "Sim" : "Não"}</td>
                    <td data-title="Brinquedo">{d.qr_code_brinquedo_text != null ? "Sim" : "Não"}</td>
                    <td data-title="Retirada Cesta">{formatDatesHoras(d.data_retirada_cesta) || "-"}</td>
                    <td data-title="Retirada Brinquedo">{formatDatesHoras(d.data_retirada_brinquedo) || "-"}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </Table>
        <Pagination page={page} setPage={setPage} totalPages={totalPages} />
      </Container>
    </Background>
  );
}
